import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ConstantsProvider} from './constants-provider.service';
import {map} from 'rxjs/operators';
import {GenericDataProviderInterface} from '../gem-util/GenericDataProviderInterface';

@Injectable()
export class StudentsProvider implements GenericDataProviderInterface {

    constructor(
        private _httpClient: HttpClient,
        private constantsService: ConstantsProvider
    ) {
    }

    /**
     * Get courses
     *
     * @returns {Promise<any>}
     */
    fetchDataList(schoolId?): Observable<any> {
        const bgColors = ['web', 'android', 'cloud', 'firebase', 'cloud', 'android', 'web', 'firebase'];
        return this._httpClient.get(this.constantsService.url + 'api/Students', this.constantsService.getAuthHeaderOption())
            .pipe(map((result: any) => {
                    result.forEach(res => {
                        const index = result.indexOf(res);
                        res.bgColor = bgColors[(index % bgColors.length)];
                    });
                    return result;
                })
            );
    }

    fetchSingle(studentId): Observable<any> {
        return this._httpClient.get(this.constantsService.url + 'api/Students/' + studentId, this.constantsService.getAuthHeaderOption());
    }

    create(data): Observable<any> {
        delete data.id;
        return this._httpClient.post(this.constantsService.url + 'api/Students', data, this.constantsService.getAuthHeaderOption('application/json-patch+json'));
    }

    update(data): Observable<any> {
        return this._httpClient.put(this.constantsService.url + 'api/Students/' + data.id, data, this.constantsService.getAuthHeaderOption());
    }

}
